import { Infra3DGeoserver } from "../../layer/internal";
import { AxisLoader } from "./internal";
export class RailPosLoader extends AxisLoader {
    constructor(scene, opt_options) {
        super(scene);
        const options = opt_options || {};
        this.api = options.api || new Infra3DGeoserver(options.baseurl, options.project, scene.viewer, options.apioptions);
    }
    loadaxis(extent, srid, cbf) {
        const addconst = 30;
        const urlparams = {
            bbox: [
                extent.minx - addconst,
                extent.miny - addconst,
                extent.maxx + addconst,
                extent.maxy + addconst,
            ].join(),
            requestsrid: srid,
            order_by: "kmabsolut",
        };
        let axissegments = [];
        const all_axissegments = {
            kilometer: false,
            gleis: false,
        };
        const segmentsloaded = () => {
            if (all_axissegments.kilometer && all_axissegments.gleis) {
                const json = {
                    value: axissegments,
                };
                cbf(json);
            }
        };
        this.api.readfeatures("kilometerachselemente", (geojson) => {
            let k_axissegments = AxisLoader.orderByAxisId(geojson, "idkilometerachse", 0.001);
            k_axissegments = RailPosLoader.mapProperties(k_axissegments, {
                bezkilometerachse: "name",
            }, {
                type: "Kilometerachse",
            });
            axissegments = axissegments.concat(k_axissegments);
            all_axissegments.kilometer = true;
            segmentsloaded();
        }, (message) => {
            all_axissegments.kilometer = true;
            segmentsloaded();
            console.log(message);
        }, urlparams);
        this.api.readfeatures("gleisachselemente", (geojson) => {
            let g_axissegments = RailPosLoader.orderByAxisId(geojson, "idgleisachsabschnitt", 0.001);
            g_axissegments = RailPosLoader.mapProperties(g_axissegments, {
                bezgleisachsabschnitt: "name",
            }, {
                type: "Gleisachse",
            });
            axissegments = axissegments.concat(g_axissegments);
            all_axissegments.gleis = true;
            segmentsloaded();
        }, (message) => {
            all_axissegments.gleis = true;
            segmentsloaded();
            console.log(message);
        }, urlparams);
    }
    static mapProperties(axissegments, map, adds) {
        for (const axissegment of axissegments) {
            for (const feature of axissegment.value.features) {
                for (const key in map) {
                    feature.properties[map[key]] = feature.properties[key];
                }
                for (const key in adds) {
                    feature.properties[key] = adds[key];
                }
            }
        }
        return axissegments;
    }
}
//# sourceMappingURL=railpos.js.map